import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_PRICE_LIST_FACILITY_COLLECTION_NAME = "price-list-facility";

export const useRxCollectionPriceListFacility =
  (): RxCollection<PriceListFacility> | null =>
    useRxCollection<PriceListFacility>(
      RXDB_PRICE_LIST_FACILITY_COLLECTION_NAME,
    );

type UseRxData = Parameters<typeof useRxData<PriceListFacility>>;
export type PriceListFacilityQueryConstructor = UseRxData["1"];

const PRICE_LIST_FACILITY_SCHEMA_LITERAL = {
  title: "price list facility schema",
  version: 1,
  description:
    "Represents api-price-list's view of a facility's price-list configuration",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    organisationId: {
      type: "string",
    },
    priceListId: {
      type: ["string", "null"],
    },
    linkedOrganisationPriceListId: {
      type: ["string", "null"],
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "organisationId", "meta"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(PRICE_LIST_FACILITY_SCHEMA_LITERAL);

export type PriceListFacility = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const PRICE_LIST_FACILITY_SCHEMA: RxJsonSchema<PriceListFacility> =
  PRICE_LIST_FACILITY_SCHEMA_LITERAL;
